module.exports = __webpack_public_path__ + "img/11_80.9125db6c.png";